import { motion } from 'motion/react'
import type { ReactNode } from 'react'

export function Reveal({
  order,
  className,
  children,
  noY,
}: {
  order: number
  className?: string
  children: ReactNode
  noY?: boolean
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: noY ? 0 : 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.45,
        ease: 'easeOut',
        delay: 0.15 + (order - 1) * 0.8,
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
